import type { BackfillState } from '@/lib/api/sources.ts'

const dayFormatter = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC',
})

/**
 * The covered interval as two dates a person reads, or `null` when nothing
 * was ever imported. The right edge is exclusive on the wire, so the last
 * covered day is the day before it.
 */
export function describeCoverage(state: BackfillState | null): { from: string; to: string } | null {
  if (!state || state.backfilledFrom === null || state.backfilledTo === null) return null
  const lastDay = new Date(state.backfilledTo.getTime() - 1)
  return { from: dayFormatter.format(state.backfilledFrom), to: dayFormatter.format(lastDay) }
}
